/**
 * BottomNav — the fixed mobile tab bar (hidden on lg+).
 *
 * Three equal tabs: Home · Categories · Cart. The old right-aligned yellow cart
 * pill is gone; Cart is now a normal tab that highlights in the SAME orange as
 * the floating cart popup, so the two share one colour language.
 */

import { NavLink } from 'react-router-dom';
import { Home, LayoutGrid, ShoppingCart } from 'lucide-react';
import { useCart } from '@/context/CartContext';
import { ROUTES } from '@/constants/routes';
import { cn } from '@/lib/cn';

export function BottomNav() {
  const { itemCount } = useCart();

  return (
    <nav className="fixed inset-x-0 bottom-0 z-40 border-t border-line bg-white lg:hidden">
      <div className="mx-auto flex max-w-6xl items-stretch">
        <Tab to={ROUTES.home} label="Home" icon={Home} end />
        <Tab to={ROUTES.categories} label="Categories" icon={LayoutGrid} />
        <Tab to={ROUTES.cart} label="Cart" icon={ShoppingCart} badge={itemCount} />
      </div>
    </nav>
  );
}

function Tab({ to, label, icon: Icon, end, badge = 0 }) {
  return (
    <NavLink
      to={to}
      end={end}
      className={({ isActive }) =>
        cn(
          'flex flex-1 flex-col items-center gap-0.5 py-2.5 text-xs font-medium transition-colors',
          isActive ? 'text-primary-600' : 'text-muted hover:text-ink',
        )
      }
    >
      {({ isActive }) => (
        <>
          <span className="relative">
            <Icon size={22} strokeWidth={isActive ? 2.5 : 2} />
            {badge > 0 && (
              <span className="absolute -right-2 -top-1.5 grid h-4 min-w-4 place-items-center rounded-full bg-primary-500 px-1 text-[10px] font-bold text-ink">
                {badge}
              </span>
            )}
          </span>
          {label}
        </>
      )}
    </NavLink>
  );
}

export default BottomNav;
